export default __webpack_public_path__ + "static/media/LHDita.eb2a4420.pdf";